'use client';
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useId } from 'react';
import { Search as SearchIcon } from 'lucide-react';
import { useDataTable } from './context';
import styles from './DataTable.module.css';
export function Search({ columnId, placeholder = 'Search…', 'aria-label': ariaLabel }) {
    const { table } = useDataTable();
    const inputId = useId();
    const value = columnId
        ? table.getColumn(columnId)?.getFilterValue() ?? ''
        : table.getState().globalFilter ?? '';
    function handleChange(e) {
        const v = e.target.value;
        if (columnId) {
            table.getColumn(columnId)?.setFilterValue(v || undefined);
        }
        else {
            table.setGlobalFilter(v || undefined);
        }
    }
    return (_jsxs("div", { className: styles.searchWrapper, children: [_jsx("span", { className: styles.searchIcon, "aria-hidden": "true", children: _jsx(SearchIcon, { size: 14 }) }), _jsx("input", { id: inputId, type: "search", className: styles.searchInput, value: value, onChange: handleChange, placeholder: placeholder, "aria-label": ariaLabel ?? placeholder, autoComplete: "off", spellCheck: false })] }));
}
//# sourceMappingURL=Search.js.map